import { MessageActions } from 'actions';

export default MessageActions;



// WEBPACK FOOTER //
// ./src/js/services/Message.js